import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-de252714")
const _hoisted_1 = { class: "heading container mx-auto flex px-7" }
const _hoisted_2 = {
  key: 0,
  class: "w-full"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "current-fees mb-5" }
const _hoisted_7 = { class: "flex flex-none pt-[10px]" }
const _hoisted_8 = { class: "px-3" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "current-fees mb-5"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Pool details ")
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "container mx-auto" }
const _hoisted_15 = { class: "card-container" }
const _hoisted_16 = { class: "pool-data" }
const _hoisted_17 = {
  class: "container mx-auto",
  ref: "intersectionSentinel"
}
const _hoisted_18 = { class: "container mx-auto" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_PoolChart = _resolveComponent("PoolChart")!
  const _component_PoolStatCards = _resolveComponent("PoolStatCards")!
  const _component_PoolBalancesCard = _resolveComponent("PoolBalancesCard")!
  const _component_PoolUserDashboard = _resolveComponent("PoolUserDashboard")!
  const _component_PoolTransactionsCard = _resolveComponent("PoolTransactionsCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.isSegnioragePool(_ctx.poolID) == true)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "Segniorage Pool"))
              : _createCommentVNode("", true),
            (_ctx.isClassicPool(_ctx.poolID) == true)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_4, "Classic Pool"))
              : _createCommentVNode("", true),
            (_ctx.isCommunityPool(_ctx.poolID) == true)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_5, "Community Pool"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, " Dynamic swap fees: Currently " + _toDisplayString((parseFloat(_ctx.pool?.swapFee) * 100 || '-') + '%'), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (token, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "token-name flex"
              }, [
                _createElementVNode("div", null, _toDisplayString(_ctx.symbolFor(token.address)), 1),
                (idx < _ctx.tableData.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "-"))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Dynamic swap fees: Currently " + _toDisplayString((parseFloat(_ctx.pool?.swapFee) * 100 || '-') + '%'), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              class: "detail-link underline",
              to: '/pool/' + _ctx.pool?.id + '/about'
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createElementVNode("img", {
                  src: _ctx.arrow,
                  class: "ml-[12px] inline"
                }, null, 8, _hoisted_13)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_BalAssetSet, {
            size: 36,
            addresses: _ctx.iconAddresses(_ctx.tableData),
            width: 70
          }, null, 8, ["addresses"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_PoolChart, {
          pool: _ctx.pool,
          historicalPrices: _ctx.historicalPrices,
          snapshots: _ctx.snapshots,
          loading: _ctx.isLoadingSnapshots,
          totalLiquidity: _ctx.pool?.totalLiquidity,
          tokensList: _ctx.pool?.tokensList,
          poolType: _ctx.pool?.poolType
        }, null, 8, ["pool", "historicalPrices", "snapshots", "loading", "totalLiquidity", "tokensList", "poolType"]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_PoolStatCards, {
            pool: _ctx.pool,
            stakedBalance: Number(_ctx.unstakedTokens) + Number(_ctx.stakedBalance),
            poolApr: _ctx.poolApr,
            loading: _ctx.loadingPool,
            loadingApr: _ctx.loadingPool,
            aprString: _ctx.apr.yearlyAPR,
            xpolarPrice: _ctx.xpolarPrice,
            xpolarToClaim: _ctx.xpolarToClaim
          }, null, 8, ["pool", "stakedBalance", "poolApr", "loading", "loadingApr", "aprString", "xpolarPrice", "xpolarToClaim"])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["container mx-auto flex justify-center gap-8", { 'mt-[60px] flex-wrap': _ctx.isMobile, 'mt-[120px]': _ctx.isDesktop }])
    }, [
      _createVNode(_component_PoolBalancesCard, {
        pool: _ctx.pool,
        loading: _ctx.loadingPool
      }, null, 8, ["pool", "loading"])
    ], 2),
    (_ctx.account)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["container mx-auto flex justify-center gap-8", { ' mt-[60px]': _ctx.isMobile, 'mt-[120px]': _ctx.isDesktop }])
        }, [
          (Number(_ctx.stakedBalance) + Number(_ctx.unstakedTokens) > 0)
            ? (_openBlock(), _createBlock(_component_PoolUserDashboard, {
                key: 0,
                pool: _ctx.pool,
                stakedBalance: _ctx.stakedBalance,
                poolApr: _ctx.poolApr,
                loading: _ctx.loadingPool,
                xpolarPrice: _ctx.xpolarPrice,
                xpolarToClaim: _ctx.xpolarToClaim,
                dailyAPR: _ctx.apr.dailyAPR
              }, null, 8, ["pool", "stakedBalance", "poolApr", "loading", "xpolarPrice", "xpolarToClaim", "dailyAPR"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, null, 512),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.isSentinelIntersected)
        ? (_openBlock(), _createBlock(_component_PoolTransactionsCard, {
            key: 0,
            pool: _ctx.pool,
            loading: _ctx.loadingPool
          }, null, 8, ["pool", "loading"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}